export const MAX_EMAILS_LIMIT_ERROR_KEY: string = 'maxEmails';

export enum $userCreationPageParams {
  newUserIds = 'newUserIds',
}
